<template>
  <div class="service_drop_menu">
    <div class="scroll_wrap">
      <div class="row_wrap">
        <div class="col_group is_m_show">
          <router-link-ex :to="`${countryPath}/service`" class="service_title">{{ $t('service.show-all') }}</router-link-ex>
        </div>
        <service-menu-item :column="column" :mode="mode" v-for="(column, colIdx) in isMobile ? this.swapRowColWithMaxCol(serviceGnbHierarchy.projectServices,5) : serviceGnbHierarchy.projectServices" :key="colIdx" />
      </div>
      <!-- [D] 너비 고정일 경우 .row_wrap에 class="width_fixed" 추가 (클래스 추가시 3열로 고정) -->
      <div v-if="hasOrgServices" class="row_wrap">
        <service-menu-item :column="column" :mode="mode" v-for="(column, colIdx) in isMobile ? this.swapRowColWithMaxCol(serviceGnbHierarchy.orgServices, 5) : serviceGnbHierarchy.orgServices" :key="colIdx" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import { namespace, types } from '../../store/modules/service-hierarchy-store'

import ServiceMenuItem from './ServiceMenuItem'
import {namespace as commonNamespace} from "../../store/modules/common-store";

export default {
  data() {
    return {
      mode: mode
    }
  },
  created() {
    this.getServiceGnbHierarchy()
  },
  methods: {
    ...mapActions(namespace, [types.GET_SERVICE_GNB_HIERARCHY])
  },
  computed: {
    ...mapState(namespace, ['serviceGnbHierarchy']),
    hasOrgServices() {
      return !!this.serviceGnbHierarchy.orgServices && this.serviceGnbHierarchy.orgServices.length > 0
    }
  },
  components: { ServiceMenuItem }
}
</script>
